import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EFeedbackResponseType;
(function (EFeedbackResponseType) {
  EFeedbackResponseType["Npsscore"] = "npsscore";
  EFeedbackResponseType["PositiveClick"] = "positive-click";
  EFeedbackResponseType["NegativeClick"] = "negative-click";
})(EFeedbackResponseType || (EFeedbackResponseType = {}));
export let EFeedbackResponseScoreSource;
(function (EFeedbackResponseScoreSource) {
  EFeedbackResponseScoreSource["Patient"] = "patient";
  EFeedbackResponseScoreSource["Sentiment"] = "sentiment";
})(EFeedbackResponseScoreSource || (EFeedbackResponseScoreSource = {}));
export const fieldsFeedbackResponse = _extends({}, fieldsIBaseModel, {
  appointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  facility: {
    type: 'ID',
    ref: EModel.Facility
  },
  npsscore: {
    type: 'Number'
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  provider: {
    type: 'ID',
    ref: EModel.Provider
  },
  response: {
    type: 'Object'
  },
  scoreSource: {
    type: 'Option',
    values: EFeedbackResponseScoreSource
  }
});